import { BillingInfoRequest } from 'modules/global/adapters/crpAPI';

export const displayBillingInfoKeys = {
  root: ['display-billing-info'] as const,
  getBillingInfo: (billingInfoRequest: BillingInfoRequest) =>
    [...displayBillingInfoKeys.root, 'get-billing-info', billingInfoRequest] as const,
};
